import { game } from "../gameManager";
import { Ingredient, IngredientType } from "../data/ingredientModel";
import { getOneByClass } from "../util";
import { BaseSlot, Slot, FixedSlot } from "./slot";
import { data } from "../data/ingredientData";
import { Recipe } from "../data/recipeModel";
import { sounds } from "../soundManager";

export class RecipePage {
    div: HTMLElement;
    slots : BaseSlot[] = [];
    totalCost: number = 0;
    readyToBrew: boolean = false;
    starsBrewed: boolean[] = [false, false, false, false];
    
    public get isCurrentPage(){
        return game.recipeBook.currentPage === this;
    }

    public get isMastered(){
        return this.starsBrewed.every(s => s);
    }

    constructor(public recipe: Recipe) {
        // Find HTML element and keep track of it
        this.div = getOneByClass("recipe", getOneByClass("game"));

        for (let slot of recipe.requirements) {
            if (slot.type === IngredientType.Unique) {
                var ingredient = data.find(ing => ing.name === slot.ingredient);
                this.slots.push(new FixedSlot(ingredient));
            }
            else {
                this.slots.push(new Slot(slot.type));
            }
        }
    }

    // Shows this recipe on the recipe page
    showOnPage() {
        this.div.setAttribute("data-potion", this.recipe.name);
        const header = getOneByClass("header", this.div);
        const icon = getOneByClass("icon", header) as HTMLImageElement;
        icon.src = `assets/potions/${this.recipe.icon}.png`;
        getOneByClass("title", this.div).innerHTML = this.recipe.name;
        getOneByClass("description", this.div).innerHTML = this.recipe.description;
        getOneByClass("instructions", this.div).innerHTML = this.recipe.instructions;

        const prices = this.div.getElementsByClassName("money");
        for (let i=0; i<4; i++) {
            prices[i].innerHTML = this.recipe.price[i].toString();
        }
        this.updateStarsBrewed();

        const ingredientsList = getOneByClass("ingredients-list", this.div);
        ingredientsList.innerHTML = ""; // clear
        for (let slot of this.slots) {
            slot.createElement(ingredientsList);
        }

        getOneByClass("brew", this.div).onclick = () => this.brew();
        this.updateTotal();
    }

    addIngredient(ingredient: Ingredient) {
        // find an open slot if there is one, else replace an existing ingredient
        // if there are two of the same ingredient, the 1st will always be replaced
        var openSlot = this.slots.find(slot => !slot.ingredient && slot.fitsIngredient(ingredient));
        var replaceSlot = this.slots.find(slot => slot.fitsIngredient(ingredient));
        var slot = openSlot ?? replaceSlot;

        if (slot) {
            (slot as Slot).clearIngredient(false);
            slot.setIngredient(ingredient);
            this.updateTotal();

            sounds.play("drop3");
        }
    }

    // Call when ingredients are updated
    updateTotal() {
        this.totalCost = this.slots
            .map(slot => slot.ingredient?.cost ?? 0)
            .reduce((prev, curr) => prev + curr);
        const tooExpensive = this.totalCost > game.money;
        this.readyToBrew = this.slots.every(slot => slot.ingredient) && !tooExpensive;

        const button = getOneByClass("brew", this.div) as HTMLButtonElement;
        const cost = getOneByClass("cost", button);
        cost.innerHTML = this.totalCost.toString();
        tooExpensive ? cost.classList.add("too-expensive") : cost.classList.remove("too-expensive");
        button.disabled = !this.readyToBrew;
    }

    updateStarsBrewed() {
        const stars = this.div.getElementsByClassName("stars");
        for (let i=0; i<4; i++) {
            stars[i].className = "stars inline-stars" + (this.starsBrewed[i] ? " brewed" : "");
        }
    }

    brew() {
        if (this.readyToBrew) {
            game.brew(); // brew the current page (ie this one)
            this.updateTotal();
        }
    }

    onResults(starCount: number) {
        // on the results of THIS potion brewing
        if (!this.starsBrewed[starCount]) {
            this.starsBrewed[starCount] = true;

            if (this.isCurrentPage) {
                this.updateStarsBrewed();
            }

            game.checkForWin();
        }
    }
}